export interface MarkdownAnalyticsOperation {
  success: (durationMs: number) => void
  error: (code: 'size_limit' | 'processing_failed') => void
}

export interface MarkdownAnalyticsAttempt {
  success: (durationMs: number) => void
  error: (code: 'size_limit' | 'processing_failed') => void
}

export interface MarkdownAnalyticsSession {
  begin: (meaningful: boolean) => MarkdownAnalyticsAttempt | null
  dispose: () => void
}

export function createMarkdownAnalyticsSession(
  startOperation: () => MarkdownAnalyticsOperation,
): MarkdownAnalyticsSession {
  let started = false
  let disposed = false

  return {
    begin(meaningful) {
      if (!meaningful || started || disposed) return null

      started = true
      const operation = startOperation()
      let settled = false

      return {
        success(durationMs) {
          if (disposed || settled) return
          settled = true
          operation.success(durationMs)
        },
        error(code) {
          if (disposed || settled) return
          settled = true
          operation.error(code)
        },
      }
    },
    dispose() {
      disposed = true
    },
  }
}
